// Used in tiles.component.html and assignment-info-dialog.component.html

// Angular
import { Component, Input, OnInit } from "@angular/core";
// Services/Types/Helpers
import { assetTypeIds } from "@carnegie-learning/cure-types";
import {
    PPAssignment as Assignment,
    CompositeTaskAssignment,
} from "cli-types";

@Component({
    selector: "status-tabs",
    templateUrl: "./status-tabs.component.html",
    styleUrls: ["./status-tabs.component.scss"],
    standalone: false
})
export class StatusTabsComponent implements OnInit {
    readonly assetTypeIds = assetTypeIds;
    @Input() assignment: Assignment | CompositeTaskAssignment;
    @Input() topTab: boolean;

    constructor() {}

    ngOnInit(): void {}

    getAssignmentStatusInfo(
        tile: Assignment | CompositeTaskAssignment,
        value: string
    ) {
        if (tile) {
            let tabClass = "status-tab-top";
            if (!this.topTab) {
                tabClass = "status-tab-side";
            }
            if (
                tile?.status === "pending" &&
                tile?.dueStatus !== "overdue" &&
                !this.checkIfInProgress(tile)
            ) {
                if (value === "status-class") {
                    return tabClass + " pending";
                } else if (value === "status-tooltip") {
                    return "Assignment needs to be Submitted";
                }
            } else if (tile?.dueStatus === "overdue" && !tile?.evaluatedAt) {
                if (value === "status-class") {
                    return tabClass + " overdue";
                } else if (value === "status-tooltip") {
                    return "Assignment is Overdue";
                }
            } else if (
                this.checkIfInProgress(tile) &&
                tile?.dueStatus !== "overdue" &&
                !tile?.evaluatedAt
            ) {
                if (value === "status-class") {
                    return tabClass + " in-progress";
                } else if (value === "status-tooltip") {
                    return "Assignment In Progress";
                }
            } else if (tile?.completedAt && !tile?.evaluatedAt) {
                if (value === "status-class") {
                    return tabClass + " submitted";
                } else if (value === "status-tooltip") {
                    return "Assignment has been Submitted";
                }
            } else if (tile?.evaluatedAt) {
                if (value === "status-class") {
                    return tabClass + " evaluated";
                } else if (value === "status-tooltip") {
                    return "Assignment has been Evaluated";
                }
            }
        }
    }

    // Check if In Progress
    // A Bundle is In Progress if any of the activities is in the In Progress status
    checkIfInProgress(tile: Assignment | CompositeTaskAssignment) {
        if (tile && tile.asset) {
            const sat = tile.asset.assetTypeId;
            if (sat === assetTypeIds.BUNDLE) {
                // If at least 1 activity has been started and there are still un-submitted activities, show the In Progress flag
                const startedAtFound = (<Assignment>(
                    tile
                )).compositeTaskAssignments.some(
                    (activity) => activity.startedAt
                );

                const notSubmittedFound = (<Assignment>(
                    tile
                )).compositeTaskAssignments.some(
                    (activity) => !activity.completedAt
                );

                if (startedAtFound && notSubmittedFound) {
                    return true;
                }
            } else if (tile.startedAt && !tile.completedAt) {
                return true;
            }
        }
    }
}
